import axios from 'axios';
import {
  SHOW_FORM,
  SET_FORM_CUSTOM_SERVICE,
  UPDATE_ERROR,
  SET_FORM_FCL_SHIPPING,
  SET_FORM_PICKUP_JSON,
  SET_FORM_PICKUP_EXTRA,
  UPDATE_FORM_TAB_PANE,
  TOGGLE_LCL_SHIPPING_TYPE,
  SET_LCL_TOTAL_SHIPMENT,
  SET_LCL_BOX_PALLET,
  DELETE_LCL_BOX_PALLET,
  DELETE_FCL_SHIPPING,
  FORM_SUBMIT_SUCCESS,
  SET_PICKUP_EXISTING_FACTORY,
  SET_FORM_DELIVERY_JSON,
  SET_DELIVERY_EXISTING_FACTORY,
  SET_FORM_DELIVERY_EXTRA,
  SET_PICKUP_SELECTED_EXISTING_FACTORY,
  SET_DELIVERY_SELECTED_EXISTING_FACTORY,
  SET_LOAD_SUMMARY_TEXT,
  SET_QUERY_PARAMS,
  SET_LOAD_SUMMARY_LCL,
  RESET_LOAD_SUMMARY_LCL,
  SET_SLIDER_CHANGE,
  SET_FORM_ERROR_DISPLAY,
  UPDATE_FCL_COUNTER,
  UPDATE_LCL_SHIPMENT,
  SET_SEA_FCL_JSON,
  SET_SEA_LCL_JSON,
  SET_SHOW_RESULT_CARD,
  UPDATE_FORM_LCL_AIR_TYPE,
  SET_AIR_JSON,
  SET_PICKUP_DELIVERY_FACTORY,
  UPDATE_AIR_SHIPMENT,
  SHOW_FORM_VALIDATION,
  SET_SELECTED_EXISTING_FACTORY_JSON,
  SET_DELIVERY_ECOMMERCE_DATA,
  SET_DELIVERY_AMAZON_DATA,
  SAVE_SEARCH_FORM_PARAM,
  FORM_BUTTON_CLICK,
  UPDATE_EXISTING_FACTORY_PIC,
  UPDATE_EXISTING_FACTORY_DEL,
  SET_DELEIVERY_EXISTING_FACTORY, FINAL_VIEW_AFTER_SUBMIT, FINAL_SEARCH_FORM, ADD_NEW_PICKUP_FACTORY, ADD_NEW_DELIVERY_FACTORY, BACK_VIEW_AFTER_SUBMIT,
  CHANGE_FINAL_FORM_VIEW_FALSE,
  CHANGE_FINAL_FORM_BOOKING_VIEW_FALSE,
  CHANGE_BACK_FORM_BOOKING_VIEW_FALSE,
  FINAL_VIEW_AFTER_BOOKING,
  PUBLIC_USER_VIEW_AFTER_SUBMIT,
  CHANGE_PUBLIC_USER_BOOKING_VIEW_FALSE,
  STORE_NEW_ID,
  SET_USER_DETAILS,
  SET_CLIENT_JWT,
  SET_INIT_AUTH,

} from './types';

import {
  API_KEY,
  AUTH_TOKEN,
  FORM_SUBMIT_URL,
  FORM_PORT_PICKUP_URL,
  FORM_PICKUP_FACTORY_LIST,
  FORM_PORT_DELIVERY_URL,
  FORM_DELIVERY_FACTORY_LIST,
  FORM_INIT_PICKUP_DELIVERY_URL,
  FORM_DELIVERY_ECOMMERCE_URL,
  FORM_DELIVERY_AMAZON_URL,
} from '../envVariables';

import {
  get_all_ports,
  get_buying_rate,
  get_Client_Rate,
  sendSaveQuote,
  sendCreateBooking,
} from '../GraphQL/entities'

import {getJSON, postZipCodeData, } from './index';

import localFCLJSON from '../data/sea-fcl.json';
// import localFCLJSONTest from '../data/sea-fcl-test.json';
import localLCLJSON from '../data/sea-lcl.json';
import localAIRJSON from '../data/air.json';
import localFactoryListJSON from '../data/factoryList.json';
import localDeliveryEcommerceJSON from '../data/form-delivery-ecommerce.json';
import localPortsJSON from '../data/ports.json';
import localPortsManyJSON from '../data/ports-many.json';

import localFormInitJSON from '../data/form-init-data.json';

import { getRfqQuotes, getQuoteRecord } from '../util/rfqApi';
import { reportBookingCreated } from '../util/rateGateApi';
import { offerCardToFinalSearchForm } from '../util/quoteBookingForm';
import { getLCLChargeableWeight } from '../util/getLCLChargeableWeight';
import { buildOfferRateJson } from '../util/rfqOfferCards';
import { isEmpty } from '../util/isEmpty';
import { isDevENV } from '../util/isDevENV';
import getNewRatesByUUID from '../util/getNewRatesByUUID';
import { convertToMetric } from '../util/convertToMetric';
import {
  setOverlayFullScreen,
  setOverlayProgress,
  updateRateCardsInfo,
} from './code_config_actions';
import { getFclOverweightContainer } from '../util/getFclOverweightContainer';
import { checkFcl45hqPrice } from '../util/checkFcl45hqPrice';
import {
  resetSidebarRoleIncoterm,
  updateSidebarRoleIncoterm,
} from '../util/updateSidebarRoleIncoterm';
import { cleanPickupDeliveryJson } from '../util/cleanPickupDeliveryJson';
import Home from "../components/Home";
import {sendNewShipperData, sendNewDeliveryLocationData, sendBookingData, sendbookingDataFromLandingPage, getDutyAndTaxFromSimplyDuty, getHSCode, sendNewSignUpRequest} from '../GraphQL/entities';
import { setTransparentOverlay } from './code_config_actions';
const LOCAL_SERVER_URL = 'http://localhost:5000/';

// new factoty/selected existing factory fields
const BUSINESS_NAME = 'name';
const EMAIL = 'email';
const POSTAL = 'postal';
const COUNTRY = 'country';
const CITY = 'city';
const ADDRESS = 'address';
const PORT = 'port';

const CONTACT_NAME = 'contact_name';
const PHONE_NUMBER = 'phone_number';
const BUSINESS_TYPE = 'busines_type';

/**
 * @module form_action
 * @redux
 * @description These are redux actions creators related to Form page.
 * @category Form Page
 * @subcategory actions
 */

/**
 * @function
 * @name updateErrorAndLoading
 * @description It updates error message and spinner loading
 * @param {string} [error=''] - error message
 * @param {boolean} [loading=false] - should show loading spinner
 * @returns {Redux.Action} The generated action
 */
export const updateErrorAndLoading =
  (error = '', loading = false) =>
  async (dispatch) => {
    dispatch({ type: UPDATE_ERROR, payload: { error, loading } });
  };

/**
 * @function
 * @name closeModal
 * @description It closes the form modal i.e. doesn't show Form page
 * @returns {Redux.Action} The generated action
 */
export const closeModal = () => async (dispatch) => {
  dispatch({ type: SHOW_FORM, payload: false });
};


export const setFormView=()=>async (dispatch, getstate)=>{
if(getstate().form.final_view_after_submit){
  dispatch({
    type:CHANGE_FINAL_FORM_VIEW_FALSE,
    payload:false
  })
}
if(getstate().form.final_view_after_booking){
  dispatch({
    type:CHANGE_FINAL_FORM_BOOKING_VIEW_FALSE,
    payload:false
  })
}
if(getstate().form.back_view_after_booking){
  dispatch({
    type:CHANGE_BACK_FORM_BOOKING_VIEW_FALSE,
    payload:false
  })
}
if(getstate().form.public_user_view_after_submit){
  dispatch({
    type:CHANGE_PUBLIC_USER_BOOKING_VIEW_FALSE,
    payload:false
  })
}
}

/**
 * @function
 * @name updateActiveTabpane
 * @description whether LCL/AIR or FCL tab is selected on Form page.
 * `true` - FCL tab is selected. `false` - LCL/AIR tab is selected.
 * @param {boolean} data - whether FCL tab is selected
 * @returns {Redux.Action} The generated action
 */
export const updateActiveTabpane = (data) => async (dispatch) => {
  dispatch({ type: UPDATE_FORM_TAB_PANE, payload: data });
};

/**
 * @function
 * @name updateLclAirType
 * @description  it sets lcl or air mode in pallets/boxes/crates tab on form page.
 * @param {string} data - either `lcl` or `air`
 * @returns {Redux.Action} The generated action
 */
export const updateLclAirType = (data) => (dispatch) => {
  dispatch({ type: UPDATE_FORM_LCL_AIR_TYPE, payload: data });
};

// LEGACY: old new-gen action for booking (calls sendBookingData → low-code action 346d9044…).
// Replaced by Create_Quote_And_Booking which uses the BB custom function (sendCreateBooking).
// May be removed once the new booking flow is stable end-to-end.
export const Create_New_Booking =(newBooking, booking_charges) =>async (dispatch,getState)=>{
  let jwt_token = getState().route.CLIENT_TOKEN.JWT_TOKEN
  dispatch(setTransparentOverlay(true))
  // Offline POC: the real booking write (sendBookingData) needs the backend, so
  // mock a successful booking with a synthetic id — mirroring the orchestrator's
  // synthetic BKG- accept id — so the Book Now -> review -> confirmation flow can
  // be exercised end to end locally. handleCreateBooking reads result[1] as the
  // bookingId. Gated on the dev local-rates flag, so prod (flag unset) is untouched.
  if (isDevENV() && process.env.REACT_APP_USE_LOCAL_RATES === 'yes') {
    dispatch(setTransparentOverlay(false));
    return [true, 'BKG-DEV-' + Date.now().toString().slice(-6)];
  }
  try {
    const result = await sendBookingData(jwt_token, newBooking, booking_charges);
    dispatch(setTransparentOverlay(false))
    if(result){
      return result
    }else{
      dispatch(updateErrorAndLoading('Error ! Contact Prime Freight', undefined));
    }
   
  } catch (error) {
    console.error("Error:", error);
  }
}

// saveQuote-then-create-booking (decision #106 B2). The coded create-booking function does
// the BOOKING half only and needs a quoteId, so persist the Quote FIRST (saveQuote, which
// owns the quote/charges/insurance logic), then call create-booking with the booking payload
// + that quoteId. Always returns a consistent 3-tuple [success, bookingId|null, quoteId|null]
// (quoteId is the committed Quote — filled on success AND on any post-commit failure so the
// orphan is recoverable; null only when the Quote never committed). handleCreateBooking reads
// [0] and [1]; [2] is for reconcile/retry.
export const Create_Quote_And_Booking = (saveQuotePayload, bookingPayload) => async (dispatch, getState) => {
  const jwt_token = getState().route.CLIENT_TOKEN.JWT_TOKEN;
  dispatch(setTransparentOverlay(true));
  // #P2-15: track the committed quoteId at function scope so BOTH failure paths —
  // the ok=false return AND a throw from sendCreateBooking — surface the orphan
  // (a throw after the Quote committed leaves the same reconcilable orphan).
  let committedQuoteId = null;
  try {
    const quoteRes = await sendSaveQuote(jwt_token, saveQuotePayload);
    if (!quoteRes?.ok) {
      console.error('saveQuote failed before booking:', quoteRes?.error);
      dispatch(setTransparentOverlay(false));
      dispatch(updateErrorAndLoading('Could not save the quote — please contact Prime Freight', undefined));
      return [false, null, null];
    }
    committedQuoteId = quoteRes.quoteId;
    const bookingRes = await sendCreateBooking(jwt_token, { ...bookingPayload, quoteId: committedQuoteId });
    dispatch(setTransparentOverlay(false));
    // [3] = the Booking RECORD id (#188): callers pass it to acceptQuote so the RFQ
    // quote links to the real Booking; [1] stays the human-facing number for display.
    if (bookingRes?.ok) {
      // activity-crm PR-2: log the logged-in booking conversion to the BB event
      // stream (D8). Fire-and-forget — never affect the booking result.
      const webuserId = getState().route?.USER_DETAILS?.webuser?.userid;
      reportBookingCreated({ webuserId, bookingRef: bookingRes.bookingId ?? null });
      return [true, bookingRes.bookingNumber || bookingRes.bookingId, committedQuoteId, bookingRes.bookingId ?? null];
    }
    // The Quote committed but booking failed — surface the orphan quoteId so support
    // can reconcile / a retry can reuse it instead of minting a duplicate.
    console.error('create-booking failed — orphan Quote left (reconcile):', committedQuoteId, bookingRes?.error);
    dispatch(updateErrorAndLoading('Error ! Contact Prime Freight', undefined));
    return [false, null, committedQuoteId];
  } catch (error) {
    // A throw AFTER the Quote committed (e.g. sendCreateBooking rejects) is the SAME
    // orphan — return committedQuoteId here too, not just on the ok=false branch.
    console.error('Create_Quote_And_Booking error (orphan quoteId=' + committedQuoteId + '):', error);
    dispatch(setTransparentOverlay(false));
    dispatch(updateErrorAndLoading('Error ! Contact Prime Freight', undefined));
    return [false, null, committedQuoteId];
  }
};

export const Create_New_Booking_Landing_Page =(jwt_token,bookingDataCharges,bookingForm,
  shipperReceiverForm1,shipperReceiverForm2,insuranceArr, dutyTax) =>async (dispatch)=>{
  try {
    const result = await sendbookingDataFromLandingPage(jwt_token,bookingDataCharges,bookingForm,
      shipperReceiverForm1,shipperReceiverForm2,insuranceArr, dutyTax)
    dispatch(setTransparentOverlay(false))
    if(result){
      return result
    }else{
      dispatch(updateErrorAndLoading('Error ! Contact Prime Freight', undefined));
    }
  } catch (error) {
    console.error("Error:", error);
  }
}


export const Create_New_Signup_Request = (jwt_token,form1,form2, bookform,bookingDatacharges) => async (dispatch) =>{
  // console.log("jwt_token: ",jwt_token,"recatcha: ",form1,form2)
  try{
    return await sendNewSignUpRequest(jwt_token,form1,form2,bookform,bookingDatacharges)
  }catch (error) {
    console.error("Error:", error);
  }
}

export const Get_Product_HSCode =(payload) =>async (dispatch, getState)=>{
  try {
    const result = await getHSCode(payload, getState, dispatch);
    if(result[0] && result?.[1]){
      return result[1]
    }else{
      console.log("No HsCode from SimplyDuty API")
    }
  } catch (error) {
    console.error("Error:", error);
  }
  }

export const Get_Duty_And_Tax =(payload) =>async (dispatch,getState)=>{
  try {
    const result = await getDutyAndTaxFromSimplyDuty(payload, getState, dispatch);
    if(result[0] && result?.[1]){
      return result[1]
    }else{
      console.log("No result from SimplyDuty API")
    }
   
  } catch (error) {
    console.error("Error:", error);
  }
}

export const Create_New_Factory=(newfactory,isPickupFactory)=>async (dispatch,getstate)=>{
  try {
   let jwt_token = getstate().route.CLIENT_TOKEN.JWT_TOKEN
   const existingFactoryJson =isPickupFactory? getstate().form.pickup.existingFactoryJson:getstate().form.delivery.existingFactoryJson;

   const consigneeRole = getstate().code_config.transactionType
  let response;
  if(consigneeRole === 'Importer'){
    if(isPickupFactory){
      response = await sendNewShipperData(jwt_token,newfactory,true);
    }else{
      response = await sendNewDeliveryLocationData(jwt_token,newfactory,true);
    }
  }else{
    if(isPickupFactory){
      response = await sendNewDeliveryLocationData(jwt_token,newfactory,true);
    }else{
      response = await sendNewShipperData(jwt_token,newfactory,true);
    }
  }
  if (response.status === 200 && response.data.data.action.results) {
    const newID = response.data.data.action.results
    newfactory.id = newID
    existingFactoryJson.push(newfactory)
    // Dispatch the action to store the newID in Redux
    dispatch(storeNewId(newID));
  }
  if(isPickupFactory){
    dispatch({
      type:ADD_NEW_PICKUP_FACTORY,
      payload:existingFactoryJson
    })
    }
    else {
    dispatch({
      type:ADD_NEW_DELIVERY_FACTORY,
      payload:existingFactoryJson
    })
  }
  } catch(error){
    console.error("Error:", error);
  }
}

export const Update_Factory_select =(selectedFactoryJson,isPickupFactory)=>async (dispatch, getState)=>{
  if(Object.keys(selectedFactoryJson).length > 0){
    selectedFactoryJson.isExistingFactorySelected=true
  }
  if(isPickupFactory){
  dispatch({
    type:SET_PICKUP_EXISTING_FACTORY,
    payload:selectedFactoryJson
  })
  } else {
  dispatch({
    type:SET_DELEIVERY_EXISTING_FACTORY,
    payload:selectedFactoryJson
  })
}

}

export const set_form_error_display = (payload) => async (dispatch, getstate) => {
  dispatch({
    type: SET_FORM_ERROR_DISPLAY,
    payload: payload
  })
}


export const setLCLSliderChange = (value) => (dispatch, getState) =>{
  dispatch({type:SET_SLIDER_CHANGE, payload: value})
}

export const final_submit_button= (result)=>async (dispatch,getState)=>{
dispatch({
  type: FINAL_VIEW_AFTER_SUBMIT,
  payload: result,

})
}

export const public_user_submit_button= (result)=>async (dispatch,getState)=>{
  dispatch({
    type: PUBLIC_USER_VIEW_AFTER_SUBMIT,
    payload: result,
  })
}

export const back_submit_button= (result)=>async (dispatch,getState)=>{
  dispatch({
    type: BACK_VIEW_AFTER_SUBMIT,
    payload: result,
  
  })
  }

export const final_booking_button= (result)=>async (dispatch,getState)=>{
  dispatch({
    type: FINAL_VIEW_AFTER_BOOKING,
    payload: result,
  
  })
  }

  export const storeNewId = (newId) => {
    return {
      type: STORE_NEW_ID,
      payload: newId,
    };
  };



export const Update_In_Existing_Factory =(factory_Json, ispickup)=>async (dispatch,getState)=>{

  const existingFactoryJson =ispickup? getState().form.pickup.existingFactoryJson:getState().form.delivery.existingFactoryJson;
  const index = existingFactoryJson.findIndex(object => object.id === factory_Json.id);

  let jwt_token = getState().route.CLIENT_TOKEN.JWT_TOKEN
let factory_with_index={
    "index":index,
    "updatedValue":factory_Json
}

  if(ispickup){
    dispatch({
      type:UPDATE_EXISTING_FACTORY_PIC,
      payload:factory_with_index
    })
   sendNewShipperData(jwt_token,factory_Json,false);
  }else {
    dispatch({
      type:UPDATE_EXISTING_FACTORY_DEL,
      payload:factory_with_index
    })
   sendNewDeliveryLocationData(jwt_token,factory_Json,false);
  }

}

/**
 * @function
 * @name getFormInitPickupDeliveryData
 * @description It makes network request to get the initial/default pickup/delivery json on form page
 * and saves the data in redux store
 * @returns {Redux.Action} The generated action
 */
export const getFormInitPickupDeliveryData = () => async (dispatch, getState) => {
    // try {
    //   const inputParams = {
    //     apiKey: API_KEY,
    //     Authorization: `Bearer ${AUTH_TOKEN}`,
    //     user: getState().code_config.initAuth.user,
    //     verification: getState().code_config.initAuth.verification,
    //   };
    //
    //   dispatch(updateErrorAndLoading(undefined, true));
    //
    //   let response = {};
    //   // if (isDevENV()) {
    //   //   // response.data = localFormInitJSON;
    //   //   await new Promise((resolve) =>
    //   //     setTimeout(() => {
    //   //       response.data = localFormInitJSON;
    //   //       // console.log('inside timeout');
    //   //       resolve();
    //   //     }, 2000)
    //   //   );
    //   // } else {
    //   //   response = await axios.get(FORM_INIT_PICKUP_DELIVERY_URL, {
    //   //     params: inputParams,
    //   //   });
    //   // }
    //
    //   if (!response.data || isEmpty(response.data)) {
    //     return;
    //   }
    //   // dispatch actions to update redux store
    //   // for pickup
    //   const pickup = response.data.pickup;
    //   // if (pickup && !isEmpty(pickup) && typeof pickup.type_port === 'boolean') {
    //   //   // for port type
    //   //   if (pickup.type_port) {
    //   //     //check if port exist or not
    //   //     dispatch(
    //   //       getRemotePickupData((portJson = undefined) => {
    //   //         // console.log('after pickup port: ', portJson);
    //   //         let tempPickupObj = {};
    //   //         portJson &&
    //   //           Array.isArray(portJson.Ports) &&
    //   //           portJson.Ports.forEach((port) => {
    //   //             if (port.id === pickup.id) {
    //   //               tempPickupObj = port;
    //   //             }
    //   //           });
    //   //         if (tempPickupObj && !isEmpty(tempPickupObj)) {
    //   //           // update pickup id, country, city
    //   //           dispatch({
    //   //             type: SET_FORM_PICKUP_EXTRA,
    //   //             payload: {
    //   //               pickupType: 'port',
    //   //               id: tempPickupObj.id || '',
    //   //               city: tempPickupObj.Name || '',
    //   //               country: tempPickupObj.Country || '',
    //   //             },
    //   //           });
    //   //         }
    //   //       })
    //   //     );
    //   //   } else {
    //   //     // for factory type
    //   //     dispatch(
    //   //       getExistingFactoryPickupData((factoryJson = undefined) => {
    //   //         // console.log('after pickup existing factory');
    //   //         let tempPickupFactoryObj = {};
    //   //         let existingFactoryListArrIndex = null;
    //   //         factoryJson &&
    //   //           Array.isArray(factoryJson.factory_list) &&
    //   //           factoryJson.factory_list.forEach((factory, index) => {
    //   //             if (factory.id === pickup.id) {
    //   //               tempPickupFactoryObj = factory;
    //   //               existingFactoryListArrIndex = index;
    //   //             }
    //   //           });
    //   //         if (tempPickupFactoryObj && !isEmpty(tempPickupFactoryObj)) {
    //   //           // update pickupType to "factory"
    //   //           dispatch({
    //   //             type: SET_FORM_PICKUP_EXTRA,
    //   //             payload: {
    //   //               pickupType: 'factory',
    //   //               selectedExistingFactoryJson: tempPickupFactoryObj,
    //   //             },
    //   //           });
    //   //           // update isExistingFactorySelected, existingFactoryListArrIndex in factoryInfo
    //   //           dispatch(
    //   //             updatePickupDeliveryFactoryInfo({
    //   //               type: 'pickup',
    //   //               data: {
    //   //                 isExistingFactorySelected: true,
    //   //                 existingFactoryListArrIndex,
    //   //               },
    //   //             })
    //   //           );
    //   //         }
    //   //       })
    //   //     );
    //   //   }
    //   // }
    //
    //   // for delivery
    //   // const delivery = response.data.delivery;
    //   // if (
    //   //   delivery &&
    //   //   !isEmpty(delivery) &&
    //   //   typeof delivery.type_port === 'boolean'
    //   // ) {
    //   //   // for port type
    //   //   if (delivery.type_port) {
    //   //     //check if port exist or not
    //   //
    //   //     dispatch(
    //   //       getRemoteDelievryData((portJson = undefined) => {
    //   //         // console.log('after delivery port: ', portJson);
    //   //         let tempDeliveryObj = {};
    //   //         portJson &&
    //   //           Array.isArray(portJson.Ports) &&
    //   //           portJson.Ports.forEach((port) => {
    //   //             if (port.id === delivery.id) {
    //   //               tempDeliveryObj = port;
    //   //             }
    //   //           });
    //   //
    //   //         if (tempDeliveryObj && !isEmpty(tempDeliveryObj)) {
    //   //           // update delivery id, country, city
    //   //           // console.log({ tempDeliveryObj });
    //   //
    //   //           dispatch({
    //   //             type: SET_FORM_DELIVERY_EXTRA,
    //   //             payload: {
    //   //               deliveryType: 'port',
    //   //               id: tempDeliveryObj.id || '',
    //   //               city: tempDeliveryObj.Name || '',
    //   //               country: tempDeliveryObj.Country || '',
    //   //             },
    //   //           });
    //   //         }
    //   //       })
    //   //     );
    //   //   } else {
    //   //     // for factory type
    //   //     dispatch(
    //   //       getExistingFactoryDeliveryData((factoryJson = undefined) => {
    //   //         // console.log('after delivery existing factory');
    //   //         let tempDeliveryFactoryObj = {};
    //   //         let existingFactoryListArrIndex = null;
    //   //         factoryJson &&
    //   //           Array.isArray(factoryJson.factory_list) &&
    //   //           factoryJson.factory_list.forEach((factory, index) => {
    //   //             if (factory.id === delivery.id) {
    //   //               tempDeliveryFactoryObj = factory;
    //   //               existingFactoryListArrIndex = index;
    //   //             }
    //   //           });
    //   //         if (tempDeliveryFactoryObj && !isEmpty(tempDeliveryFactoryObj)) {
    //   //           dispatch({
    //   //             type: SET_FORM_DELIVERY_EXTRA,
    //   //             payload: {
    //   //               deliveryType: 'factory',
    //   //               selectedExistingFactoryJson: tempDeliveryFactoryObj,
    //   //             },
    //   //           });
    //   //           // update isExistingFactorySelected, existingFactoryListArrIndex in factoryInfo
    //   //           dispatch(
    //   //             updatePickupDeliveryFactoryInfo({
    //   //               type: 'delivery',
    //   //               data: {
    //   //                 isExistingFactorySelected: true,
    //   //                 existingFactoryListArrIndex,
    //   //               },
    //   //             })
    //   //           );
    //   //         }
    //   //       })
    //   //     );
    //   //   }
    //   // }
    //
    //   dispatch(updateErrorAndLoading(undefined, undefined));
    // } catch (err) {
    //   console.log(err);
    //   dispatch(updateErrorAndLoading(JSON.stringify(err.message), undefined));
    // }
  };

/**
 * @function
 * @name updateFclShipping
 * @description  It updates fcl shipping data in redux store on Form page.
 * @param {number} rowId - It's the `id` of added load in fcl shipping section
 * @param {Object} dataJson - It's the object contains info about added load in Fcl shipping section.
 * @returns {Redux.Action} The generated action
 */
export const updateFclShipping =
  (rowId, dataJson) => async (dispatch, getState) => {
    dispatch({
      type: SET_FORM_FCL_SHIPPING,
      payload: { id: rowId, data: dataJson },
    });
  };

/**
 * @function
 * @name deleteFclShipping
 * @description  It deletes one of added fcl shipping load on Form page.
 * @param {number} rowId - It's the `id` of added load to be deleted
 * @returns {Redux.Action} The generated action
 */
export const deleteFclShipping = (rowId) => async (dispatch, getState) => {
  dispatch({
    type: DELETE_FCL_SHIPPING,
    payload: { id: rowId },
  });
};

/**
 * @function
 * @name updateLclShipppingType
 * @description  Whether boxes/pallets or total shipment shipping is selected on LCL mode on form page.
 * @param {boolean} data - whether box/pallet is selected
 * @returns {Redux.Action} The generated action
 */
export const updateLclShipppingType = (data) => async (dispatch) => {
  dispatch({ type: TOGGLE_LCL_SHIPPING_TYPE, payload: data });
};

/**
 * @function
 * @name updateLclTotalShippment
 * @description  It updates lcl or air total shipment on Form page.
 * @param {Object} data - it contains info about total shipment
 * @returns {Redux.Action} The generated action
 */
export const updateLclTotalShippment = (data) => async (dispatch, getState) => {
  dispatch({ type: SET_LCL_TOTAL_SHIPMENT, payload: data });
};

/**
 * @function
 * @name updateLclBoxPallet
 * @description  It updates lcl box/pallet data on Form page.
 * @param {number} rowId - `id` of the added single box/pallet load
 * @param {Object} dataJson - it contains info about added single box/pallet load
 * @returns {Redux.Action} The generated action
 */
export const updateLclBoxPallet =
  (rowId, dataJson) => async (dispatch, getState) => {
    // console.log("dataJson: ", dataJson);

    dispatch({
      type: SET_LCL_BOX_PALLET,
      payload: { id: rowId, data: dataJson },
    });
  };

/**
 * @function
 * @name deleteLclBoxPallet
 * @description   It deletes lcl box/pallet data on Form page.
 * @param {number} rowId - `id` of the single box/pallet load to be deleted
 * @returns {Redux.Action} The generated action
 */
export const deleteLclBoxPallet = (rowId) => async (dispatch, getState) => {
  dispatch({
    type: DELETE_LCL_BOX_PALLET,
    payload: { id: rowId },
  });
};

/**
 * @function
 * @name getRemotePickupData
 * @description   It gets pickup ports json for Form page.
 * @param {Function} [callback=undefined] - callback
 * @returns {Redux.Action} The generated action
 */
export const getRemotePickupData =
  (callback = undefined) =>
  async (dispatch, getState) => {
    try {
      const inputParams = {
        apiKey: API_KEY,
        Authorization: `Bearer ${AUTH_TOKEN}`,
        user: getState().code_config.initAuth.user,
        verification: getState().code_config.initAuth.verification,
      };

      dispatch(updateErrorAndLoading(undefined, true));

      let response = {};
      if (isDevENV()) {
        // response.data = localPortsJSON;
        await new Promise((resolve) =>
          setTimeout(() => {
            response.data = localPortsJSON;
            resolve();
          }, 100)
        );
      } else {
        response = await axios.get(FORM_PORT_PICKUP_URL, {
          params: inputParams,
        });
      }
      // console.log('pickup response: ', response.data);

      dispatch({ type: SET_FORM_PICKUP_JSON, payload: response.data });
      if (callback) {
        callback(response.data);
      }

      dispatch(updateErrorAndLoading(undefined, undefined));
    } catch (err) {
      console.log(err);
      if (callback) {
        callback();
      }
      dispatch(updateErrorAndLoading(JSON.stringify(err.message), undefined));
    }
  };

/**
 * @function
 * @name getExistingFactoryPickupData
 * @description  It gets pickup existing factory list json on Form page.
 * @param {Function} [callback=undefined] - callback
 * @returns {Redux.Action} The generated action
 */
export const getExistingFactoryPickupData =
  (callback = undefined) =>
  async (dispatch, getState) => {
    try {
      const inputParams = {
        apiKey: API_KEY,
        Authorization: `Bearer ${AUTH_TOKEN}`,
        user: getState().code_config.initAuth.user,
        verification: getState().code_config.initAuth.verification,
      };

      dispatch(updateErrorAndLoading(undefined, true));

      let response = {};
      // console.log("existing factory json response: ", response.data);
      if (isDevENV()) {
        // response.data = localFactoryListJSON; //comment this line, it was for testing
        await new Promise((resolve) =>
          setTimeout(() => {
            response.data = localFactoryListJSON;
            resolve();
          }, 100)
        );
      } else {
        response = await axios.get(FORM_PICKUP_FACTORY_LIST, {
          params: inputParams,
        });
      }

      dispatch({
        type: SET_PICKUP_EXISTING_FACTORY,
        payload: response.data,
      });

      dispatch(updateErrorAndLoading(undefined, undefined));
      if (callback) {
        callback(response.data);
      }
    } catch (err) {
      console.log(err);
      if (callback) {
        callback();
      }
      dispatch(updateErrorAndLoading(JSON.stringify(err.message), undefined));
    }
  };

/**
 * @function
 * @name updatePickupData
 * @description  It updates pickup section data in redux store on Form page.
 * @param {Object} data - It contains info about pickup
 * @returns {Redux.Action} The generated action
 */
export const updatePickupData = (data) => async (dispatch, getState) => {
  dispatch({ type: SET_FORM_PICKUP_EXTRA, payload: data });
};

/**
 * @function
 * @name updateSelectedExistingFactoryPickup
 * @description  It updates pickup selected Existing Factory in redux store on Form page.
 * @param {Object} data - selected existing factory object
 * @returns {Redux.Action} The generated action
 */
export const updateSelectedExistingFactoryPickup =
  (data) => async (dispatch, getState) => {
    dispatch({ type: SET_PICKUP_SELECTED_EXISTING_FACTORY, payload: data });
  };

/**
 * @function
 * @name getRemoteDelievryData
 * @description   It gets delivery ports json for Form page.
 * @param {Function} [callback=undefined] - callback
 * @returns {Redux.Action} The generated action
 */
export const getRemoteDelievryData =
  (callback = undefined) =>
  async (dispatch, getState) => {
    try {
      const inputParams = {
        apiKey: API_KEY,
        Authorization: `Bearer ${AUTH_TOKEN}`,
        user: getState().code_config.initAuth.user,
        verification: getState().code_config.initAuth.verification,
      };

      dispatch(updateErrorAndLoading(undefined, true));

      let response = {};
      if (isDevENV()) {
        // response.data = localPortsManyJSON;
        await new Promise((resolve) =>
          setTimeout(() => {
            response.data = localPortsManyJSON;
            resolve();
          }, 100)
        );
      } else {
        response = await axios.get(FORM_PORT_DELIVERY_URL, {
          params: inputParams,
        });
      }

      // console.log("response: ", response.data);

      dispatch({ type: SET_FORM_DELIVERY_JSON, payload: response.data });
      if (callback) {
        callback(response.data);
      }

      dispatch(updateErrorAndLoading(undefined, undefined));
    } catch (err) {
      console.log(err);
      if (callback) {
        callback();
      }
      dispatch(updateErrorAndLoading(JSON.stringify(err.message), undefined));
    }
  };

/**
 * @function
 * @name getRemoteDeliveryEcommerceData
 * @description It gets E-commerce json in delivery destination location type on form page
 * @param {Function} [callback=undefined] - callback
 * @returns {Redux.Action} The generated action
 */
export const getRemoteDeliveryEcommerceData =
  (callback = undefined) =>
  async (dispatch, getState) => {
    try {
      const inputParams = {
        apiKey: API_KEY,
        Authorization: `Bearer ${AUTH_TOKEN}`,
        user: getState().code_config.initAuth.user,
        verification: getState().code_config.initAuth.verification,
      };

      dispatch(updateErrorAndLoading(undefined, true));

      let response = {};
      if (isDevENV()) {
        await new Promise((resolve) =>
          setTimeout(() => {
            response.data = localDeliveryEcommerceJSON;
            resolve();
          }, 500)
        );
      } else {
        response = await axios.get(FORM_DELIVERY_ECOMMERCE_URL, {
          params: inputParams,
        });
      }
      // console.log('ecommerce response: ', response.data);

      dispatch(saveDeliveryEcommerceData({ ecommerceJson: response.data }));

      if (callback) {
        callback(response.data);
      }

      dispatch(updateErrorAndLoading(undefined, undefined));
    } catch (err) {
      console.log(err);
      if (callback) {
        callback();
      }
      dispatch(updateErrorAndLoading(JSON.stringify(err.message), undefined));
    }
  };

/**
 * @function
 * @name saveDeliveryEcommerceData
 * @description It updates delivery selected e-commerce mode data in redux store on Form page.
 * @param {Object} ecommerceModeObj - e-commerce mode object
 * @param {Function} [callback=undefined] - callback
 * @returns {Redux.Action} The generated action
 */
export const saveDeliveryEcommerceData =
  (ecommerceModeObj, callback = undefined) =>
  async (dispatch) => {
    // console.log('ecommerce response: ', ecommerceModeObj);

    dispatch({
      type: SET_DELIVERY_ECOMMERCE_DATA,
      payload: ecommerceModeObj,
    });
  };

/**
 * @function
 * @name getRemoteDeliveryAmazonData
 * @description It gets Amazon json in delivery destination location type on form page
 * @param {Function} [callback=undefined] - callback
 * @returns {Redux.Action} The generated action
 */
export const getRemoteDeliveryAmazonData =
  (callback = undefined) =>
  async (dispatch, getState) => {
    try {
      const inputParams = {
        apiKey: API_KEY,
        Authorization: `Bearer ${AUTH_TOKEN}`,
        user: getState().code_config.initAuth.user,
        verification: getState().code_config.initAuth.verification,
      };

      dispatch(updateErrorAndLoading(undefined, true));

      let response = {};
      if (isDevENV()) {
        await new Promise((resolve) =>
          setTimeout(() => {
            response.data = localDeliveryEcommerceJSON;
            resolve();
          }, 500)
        );
      } else {
        response = await axios.get(FORM_DELIVERY_AMAZON_URL, {
          params: inputParams,
        });
      }
      // console.log('amazon response: ', response.data);

      dispatch(saveDeliveryAmazonData({ amazonJson: response.data }));

      if (callback) {
        callback(true);
      }

      dispatch(updateErrorAndLoading(undefined, undefined));
    } catch (err) {
      console.log(err);
      if (callback) {
        callback();
      }
      dispatch(updateErrorAndLoading(JSON.stringify(err.message), undefined));
    }
  };

/**
 * @function
 * @name saveDeliveryAmazonData
 * @description It updates delivery selected amazon mode data in redux store on Form page.
 * @param {Object} amazonModeObj - it contains info about selected amazon mode
 * @param {Function} [callback=undefined] - callback
 * @returns {Redux.Action} The generated action
 */
export const saveDeliveryAmazonData =
  (amazonModeObj, callback = undefined) =>
  async (dispatch) => {
    // console.log('amazon response: ', amazonModeObj);

    dispatch({
      type: SET_DELIVERY_AMAZON_DATA,
      payload: amazonModeObj,
    });
  };

/**
 * @function
 * @name updatePickupDeliveryFactoryInfo
 * @description It sets whether existing factory is selected or not, and selected existing factory array index
 * in dropdown for both pickup and delivery existing/new factory on form page
 * @param {Object} data - it contains info about pickup/delivery factory info
 * @returns {Redux.Action} The generated action
 */
export const updatePickupDeliveryFactoryInfo = (data) => (dispatch) => {
  dispatch({ type: SET_PICKUP_DELIVERY_FACTORY, payload: data });
};

/**
 * @function
 * @name updatePickupDeliverySelectedExistingFactory
 * @description it updates port/other data to selected Existing Factory Json for pickup/delivery on form page.
 * @param {Object} dataObj - it contains info about pickup/delivery selected existing factory
 * @returns {Redux.Action} The generated action
 */
export const updatePickupDeliverySelectedExistingFactory =
  (dataObj) => (dispatch) => {
    dispatch({
      type: SET_SELECTED_EXISTING_FACTORY_JSON,
      payload: dataObj,
    });
  };

/**
 * @function
 * @name getExistingFactoryDeliveryData
 * @description  It gets delivery existing factory list json on Form page.
 * @param {Function} [callback=undefined] - callback
 * @returns {Redux.Action} The generated action
 */
export const getExistingFactoryDeliveryData =
  (callback = undefined) =>
  async (dispatch, getState) => {
    try {
      const inputParams = {
        apiKey: API_KEY,
        Authorization: `Bearer ${AUTH_TOKEN}`,
        user: getState().code_config.initAuth.user,
        verification: getState().code_config.initAuth.verification,
      };

      dispatch(updateErrorAndLoading(undefined, true));

      let response = {};
      // console.log("existing factory json response: ", response.data);
      if (isDevENV()) {
        //response.data = localFactoryListJSON; //comment this line, it was for testing
        await new Promise((resolve) =>
          setTimeout(() => {
            response.data = localFactoryListJSON;
            resolve();
          }, 100)
        );
      } else {
        response = await axios.get(FORM_DELIVERY_FACTORY_LIST, {
          params: inputParams,
        });
      }

      dispatch({
        type: SET_DELIVERY_EXISTING_FACTORY,
        payload: response.data,
      });

      if (callback) {
        callback(response.data);
      }

      dispatch(updateErrorAndLoading(undefined, undefined));
    } catch (err) {
      console.log(err);
      if (callback) {
        callback();
      }
      dispatch(updateErrorAndLoading(JSON.stringify(err.message), undefined));
    }
  };

/**
 * @function
 * @name updateDeliveryData
 * @description  It updates delivery section data in redux store on Form page.
 * @param {Object} data - It contains info about delivery
 * @returns {Redux.Action} The generated action
 */
export const updateDeliveryData = (data) => async (dispatch, getState) => {
  dispatch({ type: SET_FORM_DELIVERY_EXTRA, payload: data });
};

/**
 * @function
 * @name updateSelectedExistingFactoryDelivery
 * @description  It updates delivery selected Existing Factory in redux store on Form page.
 * @param {Object} data - selected existing factory object
 * @returns {Redux.Action} The generated action
 */
export const updateSelectedExistingFactoryDelivery =
  (data) => async (dispatch, getState) => {
    // dispatch({ type: SET_DELIVERY_SELECTED_EXISTING_FACTORY, payload: data });
  };

/**
 * @function
 * @name saveCustomService
 * @description  It saves custom service section data in redux store on Form page.
 * @param {Object} data - it contains info about custom service
 * @returns {Redux.Action} The generated action
 */
export const saveCustomService = (data) => async (dispatch) => {
  dispatch({ type: SET_FORM_CUSTOM_SERVICE, payload: data });
};

/**
 * @function
 * @name updateLoadSummaryText
 * @description  It creates summary text and saves it in redux store on Form page.
 * @returns {Redux.Action} The generated action
 */
export const updateLoadSummaryText = () => async (dispatch, getState) => {
  const isFclTabActive = getState().form.isFclTabActive;

  if (isFclTabActive) {
    let noOfContainers = 0;
    const fclShipping = getState().form.fclShipping;

    Object.keys(fclShipping).forEach((key) => {
      let input = fclShipping[key] && fclShipping[key].input;
      if (input) {
        noOfContainers += input;
      }
    });
    dispatch({
      type: SET_LOAD_SUMMARY_TEXT,
      payload: `Total: ${noOfContainers} Containers`,
    });
  } else {
    // for lcl
    const { summaryText } = calculateLclAirShipment(getState);

    dispatch({
      type: SET_LOAD_SUMMARY_TEXT,
      payload: summaryText,
    });
  }
};

export const updateLoadSummaryLCL = () => async (dispatch, getState) => {
  // for lcl
  const data = calculateLclLoadShipment(getState);
  dispatch({
    type: SET_LOAD_SUMMARY_LCL,
    payload: data,
  });
};

/**
 * @function
 * @name resetContainersTypeSliders
 * @description It resets selected [LCL container info]{@Link LCLContainerType} and [LCL/AIR shipment]{@Link LclAirSlider} info in sidebar.
 * @returns {Redux.Action} The generated action
 */
export const resetContainerLCLSliders = () => (dispatch, getState) => {
  const lclAirShippingLCL = getState().form.lclAirShipping
  const k = 0;
  // Loop through the boxPallet array starting from the index after the first record
  for (let i = k + 1; i < Object.keys(lclAirShippingLCL.boxPallet).length; i++) {
    // Delete the record using deleteLclBoxPallet function
    deleteLclBoxPallet(i);
  }
  dispatch({ type: RESET_LOAD_SUMMARY_LCL, payload: {} });
};

const calculateLclLoadShipment = (getState) => {
  let summaryText;
  const lclAirShipping = getState().form.lclAirShipping;
  const lclShipment = getState().code_config.lclShipment

  // for summary text
  let quantity = 0;
  let summaryVol = 0.0;
  let summaryVolUnit = lclShipment.volumeUnit;
  let summaryWt = 0.0;
  let summaryWtUnit = lclShipment.weightUnit;

  const boxPallet = lclAirShipping.boxPallet;
  let midUnit = lclShipment.volumeUnit; // final unit of dimens

  Object.keys(boxPallet || {}).forEach((key) => {
    const boxPalletRow = boxPallet[key];
    if (!boxPalletRow) {
      return;
    }
    quantity += boxPalletRow.quantity;
    const weight = (boxPalletRow.totalWeight && boxPalletRow.totalWeight!=='') ? parseFloat(boxPalletRow.totalWeight) : 0
    const volume = (boxPalletRow.totalVolume && boxPalletRow.totalVolume!=='') ? parseFloat(boxPalletRow.totalVolume) : 0

    if ((boxPalletRow.wtUnit === 'LB' && (lclShipment.weightUnit === 'LBS' || lclShipment.weightUnit === 'LB')) || (boxPalletRow.wtUnit === 'KG' && lclShipment.weightUnit === 'KG')){
      summaryWt += weight;
      summaryVol += volume;
    }else{
      if(lclShipment.weightUnit === 'KG' && boxPalletRow.wtUnit ==='LB')
      {
        summaryWt += parseFloat((weight / 2.205 ).toFixed(2));
        summaryVol += parseFloat((volume / 35.315).toFixed(2));
      }
      else if ( (lclShipment.weightUnit === 'LB' || lclShipment.weightUnit === 'LBS') && boxPalletRow.wtUnit ==='KG')
      {
        summaryWt += parseFloat((weight * 2.205).toFixed(2));
        summaryVol += parseFloat((volume * 35.315).toFixed(2));
      }
    }
  }); //end of loop

  summaryVolUnit = midUnit;

  summaryVol = isNaN(summaryVol) ? 0 : parseFloat(summaryVol).toFixed(2);
  summaryWt = isNaN(summaryWt) ? 0 : parseFloat(summaryWt).toFixed(2);
  summaryText = `Total: ${quantity} Units, ${summaryVolUnit}: ${summaryVol || 0} ,${summaryWtUnit}: ${summaryWt || 0} `;

  const lclLoadSummary={
    weight: summaryWt,
    volume: summaryVol,
    quantity: quantity
  }
  return { summaryText, lclLoadSummary };
};

/**
 * @typedef {Object} calculateLclAirShipmentReturnType
 * @property {string} summaryText - summary text e.g. `Total: 1 Units, 2.00 CBM, 2.00 KG`
 * @property {Object} lclAirShipmentFormSubmit - lcl air shipment info e.g. `{quantity, totalWeight, weightUnit, totalVolume, volumeUnit}`
 */

/**
 * @function
 * @name calculateLclAirShipment
 * @description  It saves custom service section data in redux store on Form page.
 * @param {Redux.State} getState - whole redux state
 * @returns {calculateLclAirShipmentReturnType} [See here]{@link module:form_action~calculateLclAirShipmentReturnType}
 */
const calculateLclAirShipment = (getState) => {
  let summaryText;
  // let summaryBoxPalletJson = {};
  let lclAirShipmentFormSubmit = {};
  const isLclBoxPalletSelected = getState().form.isLclBoxPalletSelected;
  const lclAirShipping = getState().form.lclAirShipping;

  // for summary text
  let quantity = 0;
  let summaryVol = 0.0;
  let summaryVolUnit = 'CBM';
  let summaryWt = 0.0;
  let summaryWtUnit = 'KG';

  if (isLclBoxPalletSelected) {
    // console.log("Lcl Box Pallet");
    const boxPallet = lclAirShipping.boxPallet;

    //let weight = 0;
    let weightUnit = 'KG';

    //let midVol = 0.0; //final volume of all rows dimens
    let midUnit = 'CBM'; // final unit of dimens

    Object.keys(boxPallet || {}).forEach((key) => {
      const boxPalletRow = boxPallet[key];

      if (!boxPalletRow) {
        return;
      }

      const rowQuantity = boxPalletRow.quantity;

      quantity += boxPalletRow.quantity;

      if (weightUnit === 'KG') {
        if (boxPalletRow.wtUnit === 'KG') {
          // new row in 'KG', old row(KG)
          //weight += parseFloat(boxPalletRow.wtValue || 0);
          weightUnit = boxPalletRow.wtUnit;
          //summary wt
          summaryWt += parseFloat(boxPalletRow.wtValue || 0) * rowQuantity;
        } else {
          // new row in 'LB', then convert old row(KG) to LB then add it to new row
          // weight = parseFloat(boxPalletRow.wtValue || 0) + parseFloat(weight * 2.205);
          weightUnit = boxPalletRow.wtUnit;

          //summary wt
          summaryWt =
            parseFloat(boxPalletRow.wtValue || 0) * rowQuantity +
            parseFloat(summaryWt * 2.205);
        }
      } else if (weightUnit === 'LB') {
        if (boxPalletRow.wtUnit === 'KG') {
          // new row in 'KG', then convert old row(LB) to KG then add it to new row
          //const tempWt = parseFloat(weight / 2.205).toFixed(2);
          // weight = parseFloat(boxPalletRow.wtValue || 0) + parseFloat(tempWt);
          weightUnit = boxPalletRow.wtUnit;
          //summary wt
          const tempSummaryWt = parseFloat(summaryWt / 2.205).toFixed(2);
          summaryWt =
            parseFloat(boxPalletRow.wtValue || 0) * rowQuantity +
            parseFloat(tempSummaryWt);
        } else {
          // new row in 'LB',old row(LB)
          //weight += parseFloat(boxPalletRow.wtValue || 0);
          weightUnit = boxPalletRow.wtUnit;

          //summary wt
          summaryWt += parseFloat(boxPalletRow.wtValue || 0) * rowQuantity;
        }
      }
      summaryWtUnit = weightUnit;

      let dimenUnit = boxPalletRow.dimenUnit;
      let dimenLeftValue = boxPalletRow.dimenLeftValue || 0;
      let dimenMidValue = boxPalletRow.dimenMidValue || 0;
      let dimenRightValue = boxPalletRow.dimenRightValue || 0;

      let tempVol = dimenLeftValue * dimenMidValue * dimenRightValue;

      let tempFinalVol;
      if (midUnit === 'CBM') {
        //for mid cbm or cft
        if (dimenUnit === 'CM') {
          //Cubic Metres(CBM)
          tempFinalVol = parseFloat(tempVol / 1000000).toFixed(2);
          midUnit = 'CBM';
          //summary volume
          summaryVol =
            parseFloat(tempFinalVol) * rowQuantity + parseFloat(summaryVol);
          summaryVol = Number(summaryVol);
        } else {
          //IN
          //Cubic Feet(CFT)
          //convert CBM to CFT  for old cummulative value
          //midVol = parseFloat(midVol * 35.315).toFixed(2);
          tempFinalVol = parseFloat(tempVol / 1728).toFixed(2);
          midUnit = 'CFT';
          //summary volume
          summaryVol =
            Number(parseFloat(tempFinalVol) * rowQuantity) +
            Number(parseFloat(summaryVol * 35.315).toFixed(2));
        }
        //let tempAllVal = parseFloat(tempFinalVol) + parseFloat(midVol);
        //midVol = parseFloat(tempAllVal).toFixed(2);
      } else if (midUnit === 'CFT') {
        //for mid cbm or cft
        if (dimenUnit === 'CM') {
          //Cubic Metres(CBM)
          //convert CFT to CBM  for old cummulative value
          //midVol = parseFloat(midVol / 35.315).toFixed(2);
          tempFinalVol = parseFloat(tempVol / 1000000).toFixed(2);
          midUnit = 'CBM';
          //summary volume
          // console.log({ rowQuantity, summaryVol });
          summaryVol =
            Number(parseFloat(tempFinalVol) * rowQuantity) +
            Number(parseFloat(summaryVol / 35.315).toFixed(2));
        } else {
          //IN
          //Cubic Feet(CFT)
          tempFinalVol = parseFloat(tempVol / 1728).toFixed(2);
          midUnit = 'CFT';
          //summary volume
          summaryVol =
            parseFloat(tempFinalVol) * rowQuantity + parseFloat(summaryVol);
          summaryVol = Number(summaryVol);
        }
        //let tempAllVal = parseFloat(tempFinalVol) + parseFloat(midVol);
        //midVol = parseFloat(tempAllVal).toFixed(2);
      }
    }); //end of loop
    summaryVolUnit = midUnit;

    //midVol = parseFloat(midVol).toFixed(2);
    //weight = parseFloat(weight).toFixed(2);

    //for only form POST request params
    // summaryBoxPalletJson = {
    //   quantity,
    //   volume: midVol || 0,
    //   volumeUnit: midUnit,
    //   weight,
    //   weightUnit,
    // };
  } else {
    // console.log("Lcl total shippment");
    const totalShipment = lclAirShipping.totalShipment;

    quantity = totalShipment.quantity;

    summaryVol = totalShipment.totalVolume;
    summaryVolUnit = totalShipment.volumeUnit;

    summaryWt = totalShipment.totalWeight;
    summaryWtUnit = totalShipment.weightUnit;
  }

  summaryVol = parseFloat(summaryVol).toFixed(2);
  summaryVol = isNaN(summaryVol) ? 0 : summaryVol;
  summaryWt = parseFloat(summaryWt).toFixed(2);
  summaryWt = isNaN(summaryWt) ? 0 : summaryWt;

  summaryText = `Total: ${quantity} Units, ${
    summaryVol || 0
  } ${summaryVolUnit}, ${summaryWt || 0} ${summaryWtUnit}`;

  lclAirShipmentFormSubmit = {
    quantity,
    totalWeight: Number(summaryWt) || 0,
    weightUnit: summaryWtUnit,
    totalVolume: Number(summaryVol) || 0,
    volumeUnit: summaryVolUnit,
  };

  // convert to metric for search bar page
  lclAirShipmentFormSubmit = convertToMetric(lclAirShipmentFormSubmit);

  // return { summaryText, lclAirShipmentFormSubmit, summaryBoxPalletJson };
  return { summaryText, lclAirShipmentFormSubmit };
};

/**
 * @function
 * @name submitForm
 * @description it submits the Form when Search & Book button is clicked
 * @param {number} data - it is only used for next-step check whether all next-step's button have been clicked
 * @returns {Redux.Action} The generated action
 */
export const submitForm = (data) => async (dispatch, getState) => {

  //check for next-steps
  let showFormCustomService = getState().code_config.showFormCustomService;
  if (getState().form.isFclTabActive) {
    //fcl
    if (data < (showFormCustomService ? 2 : 1)) {
      dispatch(
        updateErrorAndLoading("Go through all the 'NEXT STEP's", undefined)
      );
      return;
    }
  } else {
    //lcl or air
    if (data < (showFormCustomService ? 3 : 2)) {
      dispatch(
        updateErrorAndLoading("Go through all the 'NEXT STEP's", undefined)
      );
      return;
    }
  }

  try {
    // for validation in pickup, delivery selects
    dispatch({ type: SHOW_FORM_VALIDATION, payload: true });
    // if (!isDevENV()) {
    //   if (areEmptyFieldsPresent(dispatch, getState)) {
    //     return;
    //   }
    // }

    const inputParams = {
      apiKey: API_KEY,
      Authorization: `Bearer ${AUTH_TOKEN}`,
      user: getState().code_config.initAuth.user,
      verification: getState().code_config.initAuth.verification,
      referral_code: getState().code_config.referralData.referral_code,
      referral_type: getState().code_config.referralData.referral_type,
      form_params: buildFormParamsBeforeSubmit(getState) || {}, //uncommennt this
      object_type: 'rate_search',
    };

    console.log('for submit inputParams: ', inputParams);

    await doAfterFormSubmit(dispatch, getState,inputParams);

    inputParams.form_params.pickup={}
    inputParams.form_params.delivery={}
    inputParams.form_params.pickup.selectedPort=getState().route.queryParams.from
    inputParams.form_params.delivery.selectedPort=getState().route.queryParams.to
    inputParams.form_params.pickup.date=getState().route.queryParams.date
    inputParams.form_params.type = getState().route.queryParams.type


    // reset and show overlay
    dispatch(setOverlayProgress(0));
    dispatch(setOverlayFullScreen(true));

    let response = {};
    let data_from_graphql={}

    // POC-only dev fallback: when the GraphQL rate backend is unreachable (offline
    // local run), inject the bundled fixture so the results page + RFQ entry point
    // can be exercised. Gated on REACT_APP_USE_LOCAL_RATES so prod is unaffected.
    // The fixture branch short-circuits get_Client_Rate entirely — no network call,
    // no thrown error to swallow — while prod keeps the exact original behaviour.
    if (process.env.REACT_APP_USE_LOCAL_RATES === 'yes') {
      data_from_graphql = {
        status: "200",
        response: getState().form.isFclTabActive
          ? localFCLJSON
          : (getState().form.lclAirShipping.type === 'lcl' ? localLCLJSON : localAIRJSON),
      };
    } else {
      data_from_graphql = await get_Client_Rate(getState, inputParams, false, dispatch);
    }
    if(data_from_graphql.status!=="200"){
      updateErrorAndLoading(data_from_graphql.error, undefined)
    }else {
      response.data=data_from_graphql.response
      // if(response.data!==undefined){
        response.data=data_from_graphql.response
          if(response.data === undefined){
            response.data={}
            // dispatch({type:FORM_BUTTON_CLICK,payload:true})
            // dispatch({ type: FORM_SUBMIT_SUCCESS, payload: true }); // for home page fileds become read only
            // dispatch({ type: SHOW_FORM, payload: false }); // hide form, uncomment this
            // // dispatch({ type: SET_SHOW_RESULT_CARD, payload: false });

            // console.log(response.data)
          }
      console.log(response)

      // if (isDevENV()) {
        //   response.data = {};
        //   await new Promise((resolve) => setTimeout(() => resolve(), 500));
        // } else {
        //   response = await axios.post(FORM_SUBMIT_URL, {
        //     params: inputParams,
        //   });
        // }

        // if (!response.data) {
        //   return;
        // }

        // reset sidebar services
        resetSidebarRoleIncoterm(dispatch);

        if (getState().form.isFclTabActive) {
          console.log("For FCL")
          //fcl
          // if (isDevENV()) {
          //   // response.data = localFCLJSON; //comment this line, it was for testing
          //   // console.log('dev localFCLJSON');
          //   // response.data = localFCLJSONTest;
          // }
          //
          response.data = checkFcl45hqPrice(response.data);
          //
          dispatch({
            type: SET_SEA_FCL_JSON,
            payload: response.data,
          });
        } else {
          if (getState().form.lclAirShipping.type === 'lcl') {
            console.log("For LCL")

            //lcl
            // if (isDevENV()) {
            //   response.data = localLCLJSON; //comment this line, it was for testing
            //   // console.log('dev localLCLJSON');
            // }
            //
            dispatch({
              type: SET_SEA_LCL_JSON,
              payload: response.data,
            });
          } else {
            //air
            console.log("For LCL Air")

            // if (isDevENV()) {
            //   response.data = localAIRJSON; //comment this line, it was for testing
            //   // console.log('dev localAIRJSON');
            // }
            // dispatch({ type: SET_AIR_JSON, payload: response.data });
          }
        }

        // reset rate cards state whether cards are expanded or not
        dispatch(updateRateCardsInfo(null));

        // update sidebar checkboxes based on all cards
        updateSidebarRoleIncoterm(response.data, dispatch);


        // to show when no rates are found
        // dispatch({
        //   type: SAVE_SEARCH_FORM_PARAM,
        //   payload: { response, show: true },
        // });


        // for data polling
        //don't do data polling byuuid if on landing page
        // console.log('Home dataPolling?: ', dataPolling);
        // if (getState().code_config.dataPolling) {
        //   console.log("in polling")
        //   // console.log('should do data polling: ', dataPolling);
        //   // get new rate + old rate
        //   // it will also remove old timer id regardless of whether uuid present or not
        //   await getNewRatesByUUID(
        //     getState().route.queryParams,
        //     response.data,
        //     dispatch,
        //     getState
        //   );
        // }



        // this.getJSON()
        // console.log(this.props)
        // this.state.route.getJSON
        dispatch({type:FORM_BUTTON_CLICK,payload:true})
        dispatch({ type: FORM_SUBMIT_SUCCESS, payload: true }); // for home page fileds become read only
        dispatch({ type: SHOW_FORM, payload: false }); // hide form, uncomment this
      if(response.data.rates!==undefined){
        dispatch({ type: SET_SHOW_RESULT_CARD, payload: false });
      }else{
        dispatch({
          type: SET_SHOW_RESULT_CARD,
          payload: isEmpty(response.data),
        });
        let object={
          form_params:inputParams.form_params,
          show:true
        }

        dispatch({
          type:SAVE_SEARCH_FORM_PARAM,
          payload:object
        })
      }


        // dispatch(updateErrorAndLoading(undefined, undefined));
        //
        // // make zip code request for new/existing factory
        // postFormFactoryZipCode(dispatch, getState);

      // }else{
      //   dispatch(updateErrorAndLoading(JSON.stringify(data_from_graphql.error), undefined));
      //   // dispatch({ type: SET_SHOW_RESULT_CARD, payload: isEmpty(response.data),});
      // }

    }

  } catch (err) {
    console.log(err);
    dispatch({ type: SHOW_FORM, payload: true });
    dispatch(updateErrorAndLoading(JSON.stringify(err.message), undefined));
  }
  // finalize overlay
  dispatch(setOverlayProgress(100));
  // hide overlay
  dispatch(setOverlayFullScreen(false));
};

/**
 * @function
 * @name loadLocalRatesForDev
 * @description POC dev-only helper. On a local-only run the live GraphQL rate
 * backend — and the origin/destination autocomplete that drives the search form —
 * is unreachable, so the results screen (and the "Create RFQ" entry point mounted
 * on the rate cards) can't be reached by filling out the form by hand. This renders
 * the bundled FCL fixture straight into the results view, mirroring submitForm's
 * FCL success path, so the whole Create-RFQ flow can be exercised offline. Wired to
 * a floating dev button that only renders when REACT_APP_USE_LOCAL_RATES === 'yes',
 * so production and normal dev builds are unaffected.
 * @param {void}
 * @returns {Function} a thunk
 */
/**
 * @function
 * @name applyResultsToStore
 * @description Pushes a prepared SINGLE-mode result set into Redux exactly like a
 * successful search would, so the real results screen + rate cards render. Shared
 * by the dev sample loader and the RFQ offer-view loader (DRY). A real search
 * populates exactly ONE mode's rate JSON and clears the others — doing the same
 * here avoids a stale card/shipment from a prior load making "Book Now" read the
 * wrong (now-empty) mode and no-op. `fclCounters` is dispatched only when given
 * (the offer-view seeds the container counts; the dev loader keeps existing ones).
 * @param {Function} dispatch
 * @param {Object} payload - { queryParams, fcl, lcl, air, fclCounters }
 */
const applyResultsToStore = (dispatch, { queryParams, fcl, lcl, air, fclCounters, lclShipment, airShipment }) => {
  dispatch({ type: SET_QUERY_PARAMS, payload: queryParams });

  dispatch({ type: SET_SEA_FCL_JSON, payload: null });
  dispatch({ type: SET_SEA_LCL_JSON, payload: null });
  dispatch({ type: SET_AIR_JSON, payload: null });
  dispatch({ type: FINAL_VIEW_AFTER_SUBMIT, payload: false });
  dispatch({ type: FINAL_VIEW_AFTER_BOOKING, payload: { bookingSuccessful: false } });

  // Seed the shipment measure so the card's price math has the right basis
  // (FCL container counts; LCL/Air weight + volume). Only when given — the dev
  // sample loader keeps whatever's already in state.
  if (fclCounters) dispatch({ type: UPDATE_FCL_COUNTER, payload: fclCounters });
  if (lclShipment) dispatch({ type: UPDATE_LCL_SHIPMENT, payload: lclShipment });
  if (airShipment) dispatch({ type: UPDATE_AIR_SHIPMENT, payload: airShipment });

  if (lcl) {
    dispatch({ type: SET_SEA_LCL_JSON, payload: lcl });
  } else if (air) {
    dispatch({ type: SET_AIR_JSON, payload: air });
  } else if (fcl) {
    // Same shaping + dispatches submitForm performs on a successful FCL search.
    const data = checkFcl45hqPrice(fcl);
    resetSidebarRoleIncoterm(dispatch);
    dispatch({ type: SET_SEA_FCL_JSON, payload: data });
    dispatch(updateRateCardsInfo(null));
    updateSidebarRoleIncoterm(data, dispatch);
  }

  dispatch({ type: FORM_BUTTON_CLICK, payload: true });
  dispatch({ type: FORM_SUBMIT_SUCCESS, payload: true });
  dispatch({ type: SHOW_FORM, payload: false });
  dispatch({ type: SET_SHOW_RESULT_CARD, payload: false });
};

export const loadLocalRatesForDev = (variant = 'fcl') => (dispatch) => {
  // Seed a representative lane so the RFQ entry point prefills origin/destination.
  // Shanghai -> Toronto: a North-America delivery so the NA drayage estimate is
  // reachable. id + portCode + country let the creator's port autocomplete
  // prefill and give the live drayage/duty/insurance calls a code + country.
  const queryParams = {
    from: { id: 'CNSHA', name: 'Shanghai', city: 'Shanghai', country: 'China', portCode: 'CNSHA' },
    to: { id: 'CATOR', name: 'Toronto', city: 'Toronto', country: 'Canada', portCode: 'CATOR' },
    type: variant === 'lcl' ? 'api-lcl' : variant === 'air' ? 'api-air' : 'api-fcl',
  };

  let fcl = null;
  let lcl = null;
  let air = null;
  if (variant === 'lcl') {
    // LCL → the creator shows the weight + CBM measure (no containers).
    lcl = localLCLJSON;
  } else if (variant === 'air') {
    // Air → weight + CBM measure, AIR mode.
    air = localAIRJSON;
  } else {
    // FCL. 'partial' clones the fixture and flags a card's delivery charge as
    // un-priceable, so the in-card "Create RFQ" partial button appears once the
    // customer checks Delivery (mirrors a real can't-instantly-price lane).
    // 'estimate' does the same AND marks the card is_estimate=true → its freight
    // is NOT firm, so the creator routes FREIGHT to vendors (estimated cards are
    // RFQ-only, #174) while still carrying the estimate as a reference.
    fcl = localFCLJSON;
    if (variant === 'partial' || variant === 'estimate') {
      fcl = JSON.parse(JSON.stringify(localFCLJSON));
      const card = fcl.rates && Array.isArray(fcl.rates.fcl) && fcl.rates.fcl[0];
      if (card) {
        card.delivery_charge_error =
          'Delivery charges not available for this lane — request an RFQ.';
        if (variant === 'estimate') card.is_estimate = true;
      }
    }
  }

  applyResultsToStore(dispatch, { queryParams, fcl, lcl, air });
};

/**
 * @function
 * @name loadRfqOfferResults
 * @description Customer offer-view loader (#78 W5 follow-up). Fetches the presented
 * options for an RFQ (GET /rfq/:id/quotes from the orchestrator), maps them into
 * the rate-card shape the normal results screen renders (buildOfferRateJson), and
 * seeds Redux so the offer-view shows agent-assembled options as REAL ratesearch
 * cards. Returns a small descriptor ({ status, mode, supported, count }) so the
 * page can render its header / fall back for not-yet-mapped modes (LCL/Air).
 * @param {number|string} rfqId
 * @returns {Function} an async thunk resolving to the descriptor
 */
export const loadRfqOfferResults = (rfqId) => async (dispatch) => {
  const quotesResp = await getRfqQuotes(rfqId);
  const built = buildOfferRateJson({
    quotesResp,
    templates: { fcl: localFCLJSON, lcl: localLCLJSON, air: localAIRJSON },
  });

  if (built.supported) {
    applyResultsToStore(dispatch, {
      queryParams: built.queryParams,
      fcl: built.fclJson,
      lcl: built.lclJson,
      air: built.airJson,
      fclCounters: built.fclCounters,
      lclShipment: built.lclShipment,
      airShipment: built.airShipment,
    });
  }

  return {
    rfqId,
    status: quotesResp.status,
    mode: built.mode,
    supported: built.supported,
    lane: quotesResp.lane,
    quotes: quotesResp.quotes || [],
    count: (quotesResp.quotes || []).length,
  };
};

/**
 * @function
 * @name loadRfqQuoteBooking
 * @description Booking handoff (#188): the Portal "Accept & create booking" button
 * lands here. Seeds the offer cards (loadRfqOfferResults — which also sets
 * queryParams the booking reads), fetches the chosen Quote's record for its real
 * carrier/vessel/port/validity ids, maps the matching offer card into a
 * `final_search_form` (offerCardToFinalSearchForm), then dispatches it + the
 * final-view gate so FInalView (the real booking-confirmation screen) renders
 * pre-filled from the agreed quote — confirming there creates the Booking, and
 * the page marks the quote accepted in the orchestrator.
 * @param {number|string} rfqId
 * @param {number|string} quoteId
 * @returns {Function} async thunk resolving to { ok, mode, quoteId } | { ok:false, error }
 */
export const loadRfqQuoteBooking = (rfqId, quoteId) => async (dispatch, getState) => {
  const desc = await dispatch(loadRfqOfferResults(rfqId));
  if (!desc.supported) {
    return { ok: false, error: `Booking isn't supported yet for this mode (${desc.mode}).` };
  }
  const route = getState().route || {};
  const cards =
    route.seaFCLJSON?.rates?.fcl || route.seaLCLJSON?.rates?.lcl || route.airJSON?.rates?.air || [];
  const card = cards.find((c) => c && c.rfqOffer && String(c.rfqOffer.quoteId) === String(quoteId));
  if (!card) {
    return { ok: false, error: `Quote #${quoteId} wasn't found among this RFQ's presented options.` };
  }
  const record = await getQuoteRecord(quoteId);
  // #P2-3: lclShipment/airShipment/fclCounters live in the code_config slice
  // (UPDATE_LCL/AIR_SHIPMENT + UPDATE_FCL_COUNTER are handled ONLY by
  // code_config_reducer — route_reducer sets none), so reading them off `route`
  // always yielded undefined in the "Accept & create booking" handoff (#188).
  const cc = getState().code_config || {};
  const shipment = desc.mode === 'air' ? cc.airShipment : cc.lclShipment;
  const chargeableWeight = desc.mode === 'lcl' ? getLCLChargeableWeight(shipment) : undefined;
  const form = offerCardToFinalSearchForm({
    card, record, mode: desc.mode, counters: cc.fclCounters, shipment, chargeableWeight,
  });
  dispatch({ type: FINAL_SEARCH_FORM, payload: form });
  dispatch({ type: FINAL_VIEW_AFTER_SUBMIT, payload: true });
  return { ok: true, mode: desc.mode, quoteId };
};

/**
 * @function
 * @name markRfqOfferAccepted
 * @description Customer offer-view: once ONE presented option is booked, the whole
 * RFQ is accepted — so every OTHER offer card in the same view must stop being
 * bookable (#6). Each offer card is its own MainResultCard with private accept
 * state, so the shared signal lives here: flip the accepted card's rfqOffer.status
 * to 'ACCEPTED' and every sibling's to 'RFQ_CLOSED' (a non-PRESENTED state the
 * accept gate already treats as "No longer available"), then re-seed the populated
 * mode's rate JSON so all cards re-render from the store.
 * @param {number|string} acceptedQuoteId - the quote the customer just booked
 * @returns {Function} a thunk
 */
export const markRfqOfferAccepted = (acceptedQuoteId) => (dispatch, getState) => {
  const { seaFCLJSON, seaLCLJSON, airJSON } = getState().route;
  const closeSiblings = (cards) =>
    (cards || []).map((card) => {
      if (!card || !card.rfqOffer) return card;
      const isAccepted = String(card.rfqOffer.quoteId) === String(acceptedQuoteId);
      return { ...card, rfqOffer: { ...card.rfqOffer, status: isAccepted ? 'ACCEPTED' : 'RFQ_CLOSED' } };
    });

  if (seaFCLJSON && seaFCLJSON.rates && Array.isArray(seaFCLJSON.rates.fcl)) {
    dispatch({
      type: SET_SEA_FCL_JSON,
      payload: { ...seaFCLJSON, rates: { ...seaFCLJSON.rates, fcl: closeSiblings(seaFCLJSON.rates.fcl) } },
    });
  } else if (seaLCLJSON && seaLCLJSON.rates && Array.isArray(seaLCLJSON.rates.lcl)) {
    dispatch({
      type: SET_SEA_LCL_JSON,
      payload: { ...seaLCLJSON, rates: { ...seaLCLJSON.rates, lcl: closeSiblings(seaLCLJSON.rates.lcl) } },
    });
  } else if (airJSON && airJSON.rates && Array.isArray(airJSON.rates.air)) {
    dispatch({
      type: SET_AIR_JSON,
      payload: { ...airJSON, rates: { ...airJSON.rates, air: closeSiblings(airJSON.rates.air) } },
    });
  }
};

/**
 * @function
 * @name devSetLoggedInUser
 * @description POC dev-only helper. A local-only run has no real login, so this
 * seeds (or clears) a fake authenticated session in Redux to test the logged-in
 * experience offline. The app uses THREE independent login signals, so a faithful
 * fake login must set all of them — setting only one leaves the others on the guest
 * path:
 *   - state.route.USER_DETAILS — gates the RFQ feature (#75 c11): banner, in-card
 *     "Create RFQ" button, per-leg RFQ radio (`USER_DETAILS?.webuser?.userid`).
 *   - state.route.CLIENT_TOKEN — "Book Now" branches on this being non-empty
 *     (MainResultCard): empty → public sign-up flow; non-empty → the logged-in
 *     booking-confirmation flow. `.JWT_TOKEN` is also the API auth token.
 *   - state.code_config.initAuth {user, verification} — the card UI's isUserPresent
 *     (save-quote button, variable-rate display) + Home's logged-in render.
 * Wired to a dev-only toggle that only renders when REACT_APP_USE_LOCAL_RATES === 'yes'.
 * @param {boolean} on - true → seed a fake logged-in session; false → clear to guest
 * @returns {Function} a thunk
 */
export const devSetLoggedInUser = (on = true) => (dispatch) => {
  dispatch({
    type: SET_USER_DETAILS,
    payload: on
      ? {
          id: 'dev-entity-456',
          webuser: {
            userid: 'dev-user-123',
            email: 'dev@example.com',
            firstName: 'Dev',
            lastName: 'User',
          },
        }
      : {},
  });
  // Non-empty CLIENT_TOKEN → "Book Now" takes the logged-in booking-confirmation
  // path instead of the public sign-up flow.
  dispatch({ type: SET_CLIENT_JWT, payload: on ? { JWT_TOKEN: 'dev-jwt-token' } : {} });
  // initAuth.{user,verification} → the logged-in card UI (save-quote / variable rate).
  dispatch({
    type: SET_INIT_AUTH,
    payload: on ? { user: 'dev-user', verification: 'dev-verification' } : {},
  });
  // Saved-factory lists for the "Select Shipper / Delivery Location" dropdowns. These
  // are normally fetched from the backend (getExistingFactory{Pickup,Delivery}Data);
  // offline the list key (form.{pickup,delivery}.existingFactoryJson) stays {} so the
  // dropdown spins forever (isEmpty → loading spinner). Seed it from the bundled
  // factoryList.json fixture so the dropdowns are usable offline (#75 dev harness).
  const devFactories = on ? (localFactoryListJSON && localFactoryListJSON.factory_list) || [] : [];
  dispatch({ type: ADD_NEW_PICKUP_FACTORY, payload: devFactories });
  dispatch({ type: ADD_NEW_DELIVERY_FACTORY, payload: devFactories });
};

/**
 * @function
 * @name areEmptyFieldsPresent
 * @description It checks whether empty form fields are present or not, upon click on 'search & book' on Form page.
 * @param {Function} dispatch - redux dispatch
 * @param {Redux.State} getState - whole redux state
 * @returns {boolean} `true` - empty form fields are present. `false` - no empty fields are found
 */
const areEmptyFieldsPresent = (dispatch, getState) => {
  //date
  let date = getState().form.pickup.date;
  if (!date) {
    dispatch(updateErrorAndLoading('"date" is empty', undefined));
    return true;
  }

  //from, pickup
  if (getState().form.pickup.pickupType === 'port') {
    if (!getState().form.pickup.city || !getState().form.pickup.country) {
      dispatch(
        updateErrorAndLoading(
          'Pickup fields are empty. Fill out all of them.',
          undefined
        )
      );
      return true;
    }
  } else {
    //factory
    let isExistingFactorySelected =
      getState().form.factoryInfo.pickup.isExistingFactorySelected;

    let selectedExistingFactoryJson =
      getState().form.pickup.selectedExistingFactoryJson || {};

    let newfactoryData = getState().form.factoryInfo.pickup.newFactory;

    // selectedExistingFactoryJson.port = {}; //comment this line

    // pickup existing factory checks
    if (isExistingFactorySelected) {
      // port
      if (
        !selectedExistingFactoryJson[PORT] ||
        isEmpty(selectedExistingFactoryJson[PORT])
      ) {
        dispatch(updateErrorAndLoading('pickup "port" is empty', undefined));
        return true;
      }
      // postal
      if (
        !selectedExistingFactoryJson[POSTAL] ||
        isEmpty(selectedExistingFactoryJson[POSTAL])
      ) {
        dispatch(updateErrorAndLoading('pickup "postal" is empty', undefined));
        return true;
      }

      if (
        !selectedExistingFactoryJson.address ||
        !selectedExistingFactoryJson.city ||
        !selectedExistingFactoryJson.country ||
        !selectedExistingFactoryJson.postal ||
        !selectedExistingFactoryJson.name ||
        (!selectedExistingFactoryJson.email &&
          !selectedExistingFactoryJson[PHONE_NUMBER]) ||
        !selectedExistingFactoryJson.port ||
        !selectedExistingFactoryJson[BUSINESS_TYPE] ||
        !selectedExistingFactoryJson[CONTACT_NAME]
      ) {
        dispatch(
          updateErrorAndLoading(
            'Pickup fields are empty. Fill out all of them.',
            undefined
          )
        );
        return true;
      }
    } else {
      //new factory checks
      if (
        !newfactoryData.address ||
        !newfactoryData.city ||
        !newfactoryData.country ||
        !newfactoryData.postal ||
        !newfactoryData.name ||
        (!newfactoryData.email && !newfactoryData[PHONE_NUMBER]) ||
        !newfactoryData.port ||
        !newfactoryData[BUSINESS_TYPE] ||
        !newfactoryData[CONTACT_NAME]
      ) {
        dispatch(
          updateErrorAndLoading(
            'Pickup fields are empty. Fill out all of them.',
            undefined
          )
        );
        return true;
      }
    }
  }

  //to, delivery
  if (getState().form.delivery.deliveryType === 'port') {
    if (!getState().form.delivery.city && !getState().form.delivery.country) {
      dispatch(
        updateErrorAndLoading(
          'Delivery fields are empty. Fill out all of them.',
          undefined
        )
      );
      return true;
    }
  } else if (getState().form.delivery.deliveryType === 'factory') {
    //factory
    let isExistingFactorySelected =
      getState().form.factoryInfo.delivery.isExistingFactorySelected;

    let selectedExistingFactoryJson =
      getState().form.delivery.selectedExistingFactoryJson || {};

    let newfactoryData = getState().form.factoryInfo.delivery.newFactory;

    // selectedExistingFactoryJson.port = {}; //comment this line

    //delivery existing factory checks
    if (isExistingFactorySelected) {
      // port
      if (
        !selectedExistingFactoryJson[PORT] ||
        isEmpty(selectedExistingFactoryJson[PORT])
      ) {
        dispatch(updateErrorAndLoading('delivery "port" is empty', undefined));
        return true;
      }
      // postal
      if (
        !selectedExistingFactoryJson[POSTAL] ||
        isEmpty(selectedExistingFactoryJson[POSTAL])
      ) {
        dispatch(
          updateErrorAndLoading('delivery "postal" is empty', undefined)
        );
        return true;
      }

      if (
        !selectedExistingFactoryJson.address ||
        !selectedExistingFactoryJson.city ||
        !selectedExistingFactoryJson.country ||
        !selectedExistingFactoryJson.postal ||
        !selectedExistingFactoryJson.name ||
        (!selectedExistingFactoryJson.email &&
          !selectedExistingFactoryJson[PHONE_NUMBER]) ||
        !selectedExistingFactoryJson.port ||
        !selectedExistingFactoryJson[BUSINESS_TYPE] ||
        !selectedExistingFactoryJson[CONTACT_NAME]
      ) {
        dispatch(
          updateErrorAndLoading(
            'Delivery fields are empty. Fill out all of them.',
            undefined
          )
        );
        return true;
      }
    } else {
      //new factory checks
      if (
        !newfactoryData.address ||
        !newfactoryData.city ||
        !newfactoryData.country ||
        !newfactoryData.postal ||
        !newfactoryData.name ||
        (!newfactoryData.email && !newfactoryData[PHONE_NUMBER]) ||
        !newfactoryData.port ||
        !newfactoryData[BUSINESS_TYPE] ||
        !newfactoryData[CONTACT_NAME]
      ) {
        dispatch(
          updateErrorAndLoading(
            'Delivery fields are empty. Fill out all of them.',
            undefined
          )
        );
        return true;
      }
    }
  } else if (getState().form.delivery.deliveryType === 'ecommerce') {
    const selectedEcommerceJson =
      getState().form.delivery.ecommerceMode.selectedEcommerceJson;
    if (!selectedEcommerceJson || isEmpty(selectedEcommerceJson)) {
      dispatch(updateErrorAndLoading('Select an ecommerce factory', undefined));
      return true;
    }
  } else if (getState().form.delivery.deliveryType === 'amazon') {
    const selectedAmazonJson =
      getState().form.delivery.amazonMode.selectedAmazonJson;
    if (!selectedAmazonJson || isEmpty(selectedAmazonJson)) {
      dispatch(updateErrorAndLoading('Select an amazon factory', undefined));
      return true;
    }
    const boxSelection = getState().form.delivery.amazonMode.boxSelection;
    const palletSelection = getState().form.delivery.amazonMode.palletSelection;

    if (!boxSelection || isEmpty(palletSelection)) {
      dispatch(
        updateErrorAndLoading(
          'Select all destination amazon packing requirements',
          undefined
        )
      );
      return true;
    }
  }

  if (getState().form.isFclTabActive) {
    //fcl
    let _20stCounter = 0;
    let _40stCounter = 0;
    let _40hqCounter = 0;
    const fclShipping = getState().form.fclShipping;

    Object.keys(fclShipping).forEach((key) => {
      let input = fclShipping[key] && fclShipping[key].input;
      let type = fclShipping[key] && fclShipping[key].type;
      if (input) {
        if (type === "20'") _20stCounter += input;
        else if (type === "40'") {
          _40stCounter += input;
        } else if (type === "40'HC") {
          _40hqCounter += input;
        }
      }
    });
    if (!_20stCounter && !_40stCounter && !_40hqCounter) {
      dispatch(updateErrorAndLoading('Add a Container', undefined));
      return true;
    }
  } else {
    //lcl
    const { lclAirShipmentFormSubmit } = calculateLclAirShipment(getState);
    let { totalWeight, weightUnit, totalVolume, volumeUnit } =
      lclAirShipmentFormSubmit;

    // console.log(
    //   'lclAirShipmentFormSubmit: wt, vol,',
    //   Number(totalWeight),
    //   Number(totalVolume)
    // );
    totalWeight = Number(totalWeight) || 0;
    totalVolume = Number(totalVolume) || 0;

    // console.log('totalWeight', totalWeight, ', totalVolume', totalVolume);

    if (!totalWeight || !totalVolume) {
      dispatch(
        updateErrorAndLoading('weight or volume field is empty/zero', undefined)
      );
      return true;
    }
  }

  return false; // no empty field found
};

/**
 * @function
 * @name cleanBoxPalletArr
 * @description It removes unnecessary properties from each and every
 *  single box/pallet added load and convert units to required units. It's only used in form submit params.
 * @param {Array.<Object>} boxPalletArr - box pallet added loads need to be cleaned
 * @returns {Array.<Object>} new cleaned box pallet array of loads
 */
const cleanBoxPalletArr = (boxPalletArr) => {
  const newBoxPalletArr = boxPalletArr.map((row) => {
    const tempRow = row && {
      packageType: row.packageType,

      quantity: row.quantity,

      dimenUnit: row.dimenUnit,
      dimenLVal: row.dimenLeftValue,
      dimenWVal: row.dimenMidValue,
      dimenHVal: row.dimenRightValue,

      wtValue: row.wtValue,
      wtUnit: row.wtUnit,
    };
    if (tempRow.wtUnit === 'LB') {
      //convert to KG
      tempRow.wtValue = parseFloat(tempRow.wtValue / 2.205).toFixed(2);
      tempRow.wtUnit = 'KG';
    }
    if (tempRow.dimenUnit === 'IN') {
      //convert to CM
      tempRow.dimenLVal = parseFloat(tempRow.dimenLVal * 2.54).toFixed(2);
      tempRow.dimenWVal = parseFloat(tempRow.dimenWVal * 2.54).toFixed(2);
      tempRow.dimenHVal = parseFloat(tempRow.dimenHVal * 2.54).toFixed(2);
      tempRow.dimenUnit = 'CM';
    }
    //volum in cm^3

    tempRow.totalVolume = parseFloat(
      (tempRow.dimenLVal * tempRow.dimenWVal * tempRow.dimenHVal) / 1000000
    ).toFixed(2);
    tempRow.totalVolumeUnit = 'CBM';

    return tempRow;
  });

  return newBoxPalletArr;
};

/**
 * @function
 * @name buildFormParamsBeforeSubmit
 * @description It builds form submit params to be sent to remote server.
 * @param {Redux.State} getState - whole redux state
 * @returns {Object}  form submit params
 */
const buildFormParamsBeforeSubmit = (getState) => {
  let params = {};
  if (getState().code_config.showFormCustomService) {
    params.customService = getState().form.customService;
  }

  params.pickup = cleanPickupDeliveryJson(getState, 'pickup').newDataJson;
  params.delivery = cleanPickupDeliveryJson(getState, 'delivery').newDataJson;

  params.factoryInfo = getState().form.factoryInfo;
  if (getState().form.isFclTabActive) {
    //fcl
    params.isFclSelected = true;
    params.type = 'api-fcl';
    let tempFclShipping = getState().form.fclShipping || {};
    // make fclShipping object to array
    let tempFclShippingArr = [];
    if (!isEmpty(tempFclShipping)) {
      let keys = Object.keys(tempFclShipping).filter(
        (key) => tempFclShipping[key] && key
      );

      keys.map((key) => tempFclShippingArr.push(tempFclShipping[key]));
    }
    // console.log('tempFclShippingArr', tempFclShippingArr);

    params.fclShipping = tempFclShippingArr;
    // add total number of overweight containers
    params.overweightContainer = getFclOverweightContainer(getState);
  } else {
    //lcl or air
    params.type =
      getState().form.lclAirShipping.type === 'lcl' ? 'api-lcl' : 'api-air';
    // let tempQuantity;
    // let tempVolume;
    // let tempVolumeUnit;
    // let tempWt;
    // let tempWtUnit;

    if (getState().form.isLclBoxPalletSelected) {
      //box-pallet
      params.isBoxPalletSelected = true;
      let tempBoxPallet = getState().form.lclAirShipping.boxPallet || {};
      // make boxPallet object to array
      if (!isEmpty(tempBoxPallet)) {
        let keys = Object.keys(tempBoxPallet).filter(
          (key) => tempBoxPallet[key] && key
        );
        tempBoxPallet = keys.map((key) => tempBoxPallet[key]);
      }
      //clean boxPallet array here
      params.boxPallet = cleanBoxPalletArr(tempBoxPallet);

      // const {
      //   summaryBoxPalletJson: {
      //     quantity,
      //     volume,
      //     volumeUnit,
      //     weight,
      //     weightUnit,
      //   },
      // } = calculateLclAirShipment(getState);
      // tempQuantity = quantity;
      // tempVolume = volume;
      // tempVolumeUnit = volumeUnit;
      // tempWt = weight;
      // tempWtUnit = weightUnit;
    } else {
      //total shipment
      params.isBoxPalletSelected = false;
      // const {
      //   quantity,
      //   totalVolume,
      //   volumeUnit,
      //   totalWeight,
      //   weightUnit,
      // } = getState().form.lclAirShipping.totalShipment;
      // tempQuantity = quantity;
      // tempVolume = totalVolume;
      // tempVolumeUnit = volumeUnit;
      // tempWt = totalWeight;
      // tempWtUnit = weightUnit;
    }

    // if (tempVolumeUnit === 'CFT') {
    //   //convert to CBM
    //   tempVolume = parseFloat(tempVolume / 1728).toFixed(2);
    //   tempVolumeUnit = 'CBM';
    // }
    // if (tempWtUnit === 'LB') {
    //   //convert to KG
    //   tempWt = parseFloat(tempWt / 2.205).toFixed(2);
    //   tempWtUnit = 'KG';
    // }

    // params.total_shipment = {
    //     quantity: tempQuantity,
    //     totalVolume: tempVolume,
    //     volumeUnit: tempVolumeUnit,
    //     totalWeight: tempWt,
    //     weightUnit: tempWtUnit,
    // };

    params.total_shipment =
      calculateLclAirShipment(getState).lclAirShipmentFormSubmit;
  }

  // console.log('before submitted params: ', params);

  return params;
};

/**
 * @function
 * @name getQueryParams
 * @description After form data is submitted,
 * this method gets `type` and `date` and these will be saved in query params in redux store.
 * @param {Redux.State} getState - whole redux state
 * @returns {Object}
 * @example
 * console.log(getQueryParams(getState));
 *
 * //output
 * {
 * type: 'api-air',
 * date: '12 May, 2020'
 * }
 */
const getQueryParams = (getState) => {
  let params = {};
  //type i.e. api-fcl or api-lcl
  if (getState().form.isFclTabActive) {
    params.type = 'api-fcl';
  } else {
    if (getState().form.lclAirShipping.type === 'lcl') {
      params.type = 'api-lcl';
    } else {
      params.type = 'api-air';
    }
  }
  //date
  params.date = getState().form.pickup.date;

  return params;
};

/**
 * @function
 * @name doAfterFormSubmit
 * @description After the form is successfully submitted,
 * it updates queryParams, FCL type  containers numbers or LCL/AIR shipment in redux store.
 * @param {Function} dispatch - redux dispatch
 * @param {Redux.State} getState - whole redux state
 * @returns {void}
 */

const set_factor_object=async (factory_object, type,getState)=>{
  let port={}
  let origin_json=getState().route.originPortJSON.Ports
  let delivery_json=getState().route.destinationPortJSON.Ports
  port.id=factory_object.port.id
  if(type==="delivery"){
    port=delivery_json.filter((object,index)=>{
      if(object.id===port.id){
        return object
      }
    })
  }else {
    port=origin_json.filter((object,index)=>{
      if(object.id===port.id){
        return object
      }
    })
  }

  return port[0]

}
const doAfterFormSubmit = async (dispatch, getState,inputParams) => {
  /*form-submit-success to true, show-form  to false as it's already done
   * add params to home page and make it only read-only
   * make search btn disable
   */

  //update queryParams
  // let pickupPort = cleanPickupDeliveryJson(
  //   getState,
  //   'pickup'
  // ).selectedPortForSearchPage;
  // pickupPort = {
  //   ...pickupPort,
  //   name: pickupPort.city || pickupPort.name || '',
  // };
  //
  let pickupPort={}
  let deliveryPort={}
  if(inputParams.form_params.pickup.pickupType==="factory"){
    let factory_object=inputParams.form_params.pickup.selectedExistingFactoryJson[0]
    pickupPort=await set_factor_object(factory_object,"pickup",getState)
  }else {
    pickupPort=inputParams.form_params.pickup.selectedPort
  }

  if(inputParams.form_params.delivery.deliveryType==="factory"){
    let factory_object=inputParams.form_params.delivery.selectedExistingFactoryJson[0]
    deliveryPort=await set_factor_object(factory_object,"delivery",getState)
  }else {
    deliveryPort=inputParams.form_params.delivery.selectedPort
  }


  // let deliveryPort = cleanPickupDeliveryJson(
  //   getState,
  //   'delivery'
  // ).selectedPortForSearchPage;
  // deliveryPort = {
  //   ...deliveryPort,
  //   name: deliveryPort.city || deliveryPort.name || '',
  // };


  const queryParams = {
    ...getQueryParams(getState),
    from: pickupPort,
    to: deliveryPort,
  };
  console.log('form queryParams', queryParams);

  dispatch({ type: SET_QUERY_PARAMS, payload: queryParams });
  //update fcl containers
  //update lcl volume, weight and units

  // if (getState().form.isFclTabActive) {
  //   //fcl
  //   let _20stCounter = 0;
  //   let _40stCounter = 0;
  //   let _40hqCounter = 0;
  //   let _45hqCounter = 0;
  //   const fclShipping = getState().form.fclShipping;
  //
  //   Object.keys(fclShipping).forEach((key) => {
  //     let input = fclShipping[key] && fclShipping[key].input;
  //     let type = fclShipping[key] && fclShipping[key].type;
  //     if (input) {
  //       if (type === "20'") {
  //         _20stCounter += input;
  //       } else if (type === "40'") {
  //         _40stCounter += input;
  //       } else if (type === "40'HC") {
  //         _40hqCounter += input;
  //       } else if (type === "45'HC") {
  //         _45hqCounter += input;
  //       }
  //     }
  //   });
  //
  //   // console.log("counters: ", _20stCounter, _40stCounter, _40hqCounter);
  //
  //   dispatch({
  //     type: UPDATE_FCL_COUNTER,
  //     payload: { _20stCounter, _40stCounter, _40hqCounter, _45hqCounter },
  //   });
  // } else {
  //   //lcl or air
  //
  //   //lcl
  //   const { lclAirShipmentFormSubmit } = calculateLclAirShipment(getState);
  //   // console.log('lclAirShipmentFormSubmit', lclAirShipmentFormSubmit);
  //
  //   if (getState().form.lclAirShipping.type === 'lcl') {
  //     dispatch({
  //       type: UPDATE_LCL_SHIPMENT,
  //       payload: lclAirShipmentFormSubmit,
  //     });
  //   } else {
  //     //air
  //     dispatch({
  //       type: UPDATE_AIR_SHIPMENT,
  //       payload: lclAirShipmentFormSubmit,
  //     });
  //   }
  // }
  //air

  // console.log('form store states: ', getState().form);
};

// (removed) postFormFactoryZipCode — the post-form-submit factory postal → Make.com
// zip webhook. Its only caller was already commented out (doAfterFormSubmit), so it was
// dead; removed in door-estimate P4. The live postZipCodeData path is untouched.

/**
 * @function
 * @name toggleFormModalVisibility
 * @description It's for showing/hiding form modal when back/edit button is clicked on search bar page.
 * @returns {Redux.Action} The generated action
 */
export const toggleFormModalVisibility = () => async (dispatch, getState) => {
  if (getState().form.isFormSubmitSuccess) {
    dispatch({ type: SHOW_FORM, payload: true });
    dispatch({ type: FORM_SUBMIT_SUCCESS, payload: true });
  }
};
